export const SCALEKIT_ENV_URL = import.meta.env.VITE_SCALEKIT_ENV_URL;
export const SCALEKIT_CLIENT_ID = import.meta.env.VITE_SCALEKIT_CLIENT_ID;
export const SCALEKIT_REDIRECT_URI = import.meta.env.VITE_SCALEKIT_REDIRECT_URI;
export const SCALEKIT_RESPONSE_TYPE = "code";
export const SCALEKIT_SCOPE = "openid profile email offline_access";
